import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGames } from '../hooks/useGameConfig';

// Подпись режима для дуэлей и списков: «Баккара: полный раунд · Лёгкий».
// Название игры — из списка игр (уже на языке пользователя), уровень — из окончания id режима
// (<gameId>-easy, -medium, -hard, -extra-hard, -expert, -custom; суффикс -stake — «с учетом ставки»).
const LEVELS = ['extra-hard', 'expert', 'easy', 'medium', 'hard', 'custom'];

export function useModeLabel() {
  const { t } = useTranslation('common');
  const { data } = useGames();
  const gameNames = useMemo(() => {
    const names = new Map<string, string>();
    for (const games of Object.values(data?.gamesByCategory || {})) for (const game of games) names.set(game.id, game.name);
    return names;
  }, [data]);

  return useCallback((gameId: string, modeId: string) => {
    const gameName = gameNames.get(gameId) || gameId;
    let rest = modeId.startsWith(`${gameId}-`) ? modeId.slice(gameId.length + 1) : modeId;
    const stake = rest.endsWith('-stake');
    if (stake) rest = rest.slice(0, -'-stake'.length);
    const level = LEVELS.includes(rest) ? t(`modeLevels.${rest}`) : rest;
    return `${gameName} · ${level}${stake ? ` (${t('modeLevels.stake')})` : ''}`;
  }, [gameNames, t]);
}

// Название игры по id на языке пользователя (значки «Мастер: <игра>»)
export function useGameName() {
  const { data } = useGames();
  const names = useMemo(() => {
    const map = new Map<string, string>();
    for (const games of Object.values(data?.gamesByCategory || {})) for (const game of games) map.set(game.id, game.name);
    return map;
  }, [data]);
  return useCallback((gameId: string) => names.get(gameId) || gameId, [names]);
}

// Только уровень режима: «Лёгкий», «Эксперт (с учетом ставки)» — для строк внутри карточки игры
export function useLevelLabel() {
  const { t } = useTranslation('common');
  return useCallback((gameId: string, modeId: string) => {
    let rest = modeId.startsWith(`${gameId}-`) ? modeId.slice(gameId.length + 1) : modeId;
    const stake = rest.endsWith('-stake');
    if (stake) rest = rest.slice(0, -'-stake'.length);
    const level = LEVELS.includes(rest) ? t(`modeLevels.${rest}`) : rest;
    return stake ? `${level} (${t('modeLevels.stake')})` : level;
  }, [t]);
}
